import { axiosPrivate } from 'shared/api';
import { ITicket } from 'features/inventory/ticketing/types';
import { BaseService } from 'shared/services/BaseService';

class TicketingService extends BaseService<ITicket> {
  constructor() {
    super('tickets');
  }
  canDelete = true;

  getClosed = async (limit = 0, offset = 0, params: Record<string, unknown> = {}) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/get_closed/`, {
      params: { limit, offset, ...params }
    });
    return res.data;
  };

  approvedByUser = async (ticketId: number) => {
    const res = await axiosPrivate.patch(`${this.modulePrefix}/${ticketId}/approved-by-user/`);
    return res.data;
  };

  sendTicket = async (ticketId: number, params: Record<string, unknown> = {}) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/${ticketId}/send-ticket/`, params);
    return res.data;
  };

  closeTicket = async (ticketId: number, params: Record<string, unknown> = {}) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/${ticketId}/close-ticket/`, params);
    return res.data;
  };

  reopenTicket = async (ticketId: number) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/${ticketId}/reopen-ticket/`);
    return res.data;
  };

  approveTicket = async (ticketId: number) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/${ticketId}/approve-ticket/`);
    return res.data;
  };

  getAlreadyApproved = async (limit = 0, offset = 0, params: Record<string, unknown> = {}) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/`, {
      params: {
        limit,
        offset,
        approvation_status: true,
        ...params
      }
    });
    return res.data;
  };

  getToBeApprove = async (limit = 0, offset = 0, params: Record<string, unknown> = {}) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/`, {
      params: {
        limit,
        offset,
        approvation_status: false,
        ...params
      }
    });
    return res.data;
  };

  getTechnicianCreated = async (limit = 0, offset = 0, params: Record<string, unknown> = {}) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/technician-created/`, {
      params: {
        limit,
        offset,
        ...params
      }
    });
    return res.data;
  };

  generateEmailPdf = async (ticketId: number) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/${ticketId}/generate-email-pdf/`);
    return res.data;
  };

  downloadEmailPdf = async (ticketId: number) => {
    axiosPrivate
      .get(`${this.modulePrefix}/${ticketId}/download-email-pdf/`, {
        responseType: 'blob'
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition?.indexOf('attachment') !== -1) {
          const filenameMatches = contentDisposition.match(
            /(?:.*filename\*|filename)=(?:([^'"]*)''|("))([^;]+)\2(?:[;`\n]|$)/
          );
          const filename = filenameMatches.pop();
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      });
  };
}

export const ticketingService = new TicketingService();
